import React from 'react'
import { Card } from '@foodsby/nutrient-v3'
import { format } from 'date-fns'

export const NoDeliveriesToday = selectedDate => (
  <Card className="NutrientV3">
    {format(Date.now(), 'dddd/MMMM/YYYY') ===
    format(selectedDate.selectedDate, 'dddd/MMMM/YYYY') ? (
      <p>There are no deliveries scheduled for Today</p>
    ) : (
      <p>
        There are no deliveries scheduled for{' '}
        {format(selectedDate.selectedDate, 'dddd')}.
      </p>
    )}
    <p style={{ marginTop: '8px' }}>
      Check out the other days to see what&apos;s ahead. And don&apos;t forget,
      you can place your order for a future day in advance!
    </p>
  </Card>
)
export default NoDeliveriesToday
